import PropTypes from 'prop-types'

const ModalButtons = ({
  containerClassName,
  primaryButtonText,
  primaryButtonDisabled,
  primaryButtonType,
  onPrimaryButtonClick,
  secondaryButtonText,
  secondaryButtonDisabled,
  secondaryButtonType,
  onSecondaryButtonClick,
}) => {
  return (
    <div className={`visitor-modal__buttons-container ${containerClassName || ''}`}>
      <button
        className="button button-gray"
        disabled={secondaryButtonDisabled}
        onClick={onSecondaryButtonClick}
        type={secondaryButtonType || 'button'}
      >
        {secondaryButtonText}
      </button>
      <button
        className="button button-black"
        disabled={primaryButtonDisabled}
        onClick={onPrimaryButtonClick}
        type={primaryButtonType || 'button'}
      >
        {primaryButtonText}
      </button>
    </div>
  )
}

ModalButtons.propTypes = {
  containerClassName: PropTypes.string,
  primaryButtonText: PropTypes.string.isRequired,
  primaryButtonDisabled: PropTypes.bool,
  primaryButtonType: PropTypes.string,
  onPrimaryButtonClick: PropTypes.func.isRequired,
  secondaryButtonText: PropTypes.string.isRequired,
  secondaryButtonDisabled: PropTypes.bool,
  secondaryButtonType: PropTypes.string,
  onSecondaryButtonClick: PropTypes.func.isRequired,
}

export default ModalButtons
